__turbopack_context__.v({
  "trigger": "AccountNavIcon-module-scss-module__yaAafG__trigger",
});
